import React, { useState } from 'react';
import { Container, Flex } from 'components/layout';
import { Customer, Search, SearchResults } from './components';

export const Home = () => {
  const [searchedFilters, setSearchedFilters] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  return (
    <Flex
      sx={{
        justifyContent: 'center',
      }}
    >
      <Container variant="page.content">
        <Search
          setSearchedFilters={setSearchedFilters}
          setSelectedCustomer={setSelectedCustomer}
        />

        <SearchResults
          searchedFilters={searchedFilters}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
        />

        <Customer
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
        />
      </Container>
    </Flex>
  );
};
